import { render } from "./LatestWorks.vue?vue&type=template&id=2d883de7&scoped=true&ts=true"
import script from "./LatestWorks.vue?vue&type=script&lang=ts"
export * from "./LatestWorks.vue?vue&type=script&lang=ts"

import "./LatestWorks.vue?vue&type=style&index=0&id=2d883de7&lang=scss&scoped=true"

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d883de7"],['__file',"resources/ts/frontend/components/LatestWorks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d883de7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d883de7', __exports__)) {
    console.log('reload')
    api.reload('2d883de7', __exports__)
  }
  
  module.hot.accept("./LatestWorks.vue?vue&type=template&id=2d883de7&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2d883de7', render)
  })

}


export default __exports__